import { render, staticRenderFns } from "./CallCenter.vue?vue&type=template&id=de1ae262&"
import script from "./CallCenter.vue?vue&type=script&lang=js&"
export * from "./CallCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports